module.exports = __webpack_public_path__ + "static/image/sustainability/img-protection-1@3x.ver2_0_2.png?60ca3e80";